import { render, staticRenderFns } from "./BlocklyEditor.vue?vue&type=template&id=608d63de&scoped=true&"
import script from "./BlocklyEditor.vue?vue&type=script&lang=js&"
export * from "./BlocklyEditor.vue?vue&type=script&lang=js&"
import style0 from "./BlocklyEditor.vue?vue&type=style&index=0&id=608d63de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608d63de",
  null
  
)

export default component.exports